import { createStyles, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useShowContext,
} from 'react-admin'
import { Authority } from '../../../../core/auth/Authority'
import { DetectorDto } from '../../../../core/dto/device/detector/detector.dto'
import { ResourceName } from '../../../../core/ResourceName'
import { ConfirmDialog } from '../../../common/ConfirmDialog'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

export const DetectorForceReportStateButton = () => {
  const { record: detector, loading } = useShowContext<DetectorDto>()
  const classes = useStyles()
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const hasAuthority = useHasAuthority()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const notify = useNotify()

  const handleMutate = async () => {
    setConfirmDialogOpen(false)
    await mutate(
      {
        type: sanitizeFetchType('forceReportState'),
        resource: ResourceName.DETECTORS,
        payload: {
          id: detector?.id,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
  }

  const handleConfirm = () => {
    setConfirmDialogOpen(true)
  }

  return (
    <>
      <ConfirmDialog
        open={confirmDialogOpen}
        confirm={handleMutate}
        source="forceReportState"
        cancel={() => setConfirmDialogOpen(false)}
        action="set"
        resource={ResourceName.DETECTORS}
      />
      <Button
        variant="contained"
        onClick={handleConfirm}
        color="primary"
        className={classes.button}
        label="resources.detectors.actions.forceReportState"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.DETECTORS_FORCE_REPORT_STATE_BUTTON) ||
          loading ||
          mutationLoading
        }
      />
    </>
  )
}
